import { CustomerColumnKey } from '../enums/customer-table-columns.enum';
import { BASE_CELL_CLASS, BASE_HEADER_CLASS } from './table-style.constants';

export interface CustomerTableColumn {
  key: CustomerColumnKey;
  label: string;
  headerClass: string;
  cellClass?: string;
  sortable?: boolean;
  isFullName?: boolean;
}

const CUSTOMERS_TABLE_HEADER_LABELS = 'customers.table.headerLabels';

export const CUSTOMER_TABLE_COLUMNS_CONFIG: readonly CustomerTableColumn[] = [
  {
    key: CustomerColumnKey.CustomerFirstName,
    label: `${CUSTOMERS_TABLE_HEADER_LABELS}.name`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--name`,
    isFullName: true,
    cellClass: BASE_CELL_CLASS,
    sortable: true,
  },
  {
    key: CustomerColumnKey.CustomerEmail,
    label: `${CUSTOMERS_TABLE_HEADER_LABELS}.email`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--email`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    key: CustomerColumnKey.CustomerPhone,
    label: `${CUSTOMERS_TABLE_HEADER_LABELS}.phone`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--phone`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    key: CustomerColumnKey.LoyaltyId,
    label: `${CUSTOMERS_TABLE_HEADER_LABELS}.loyaltyId`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--loyaltyId`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    key: CustomerColumnKey.Status,
    label: `${CUSTOMERS_TABLE_HEADER_LABELS}.status`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--status`,
    cellClass: BASE_CELL_CLASS,
    sortable: true,
  },
  {
    key: CustomerColumnKey.Actions,
    label: `${CUSTOMERS_TABLE_HEADER_LABELS}.actions`,
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--actions`,
  },
];

export const FAKE_CUSTOMERS_QUANTITY = 5;

export const CUSTOMER_DIALOG_OPTIONS = {
  width: '808px',
  maxWidth: '95vw',
  panelClass: 'no-radius-dialog',
};
